const Loading = () => {
  return (
    <div
      style={{ zIndex: "10" }}
      className="loader-container d-flex justify-content-center align-items-center position-absolute w-100 h-100"
    >
      <div
        className="loader-overlay position-absolute w-100 h-100"
        style={{
          backgroundColor: "rgba(255, 255, 255, 0.5)",
          backdropFilter: "blur(5px)",
        }}
      ></div>
      <div className="loader-container">
        <div className="loader-overlay"></div>
        <div
          style={{ borderWidth: "3px" }}
          className="spinner-border text-primary"
          role="status"
        >
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  );
};

export default Loading;
